import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';
import withStyles from 'react-jss';
import { Link } from 'react-router-dom';
import styles from './styles';

const Breadcrumbs = props => {
  const { classes, moduleName, moduleLink, subModuleName } = props;

  return (
    <Breadcrumb className={classes.breadcrumbStyle}>
      <Breadcrumb.Item>
        <Link to="/">Home</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={`${moduleLink}`}>{moduleName}</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>{subModuleName}</Breadcrumb.Item>
    </Breadcrumb>
  );
};

Breadcrumbs.propTypes = {
  classes: PropTypes.object.isRequired,
  moduleName: PropTypes.string,
  moduleLink: PropTypes.string,
  subModuleName: PropTypes.string,
};

export default withStyles(styles)(Breadcrumbs);
